<template>
<div class="container-fluid">
    <div class="pull-right" v-if="this.typeactivity === 'scaled'">
        <router-link  v-bind:to="'/Reassignment/'+ this.$route.params.id "><button class="btn btn-success">Reasignar PQR</button></router-link>
    </div>
    <div class="titlle_div">
        <h5 class="title">PQR {{ this.$route.params.id }}</h5>
    </div>
    <br>
    <div id="pqr_form">
        <div class="panel-group pqr_panel" id="accordion">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" href="javascript:;" v-on:click="pqrDisplay = !pqrDisplay" id="btn-search">Creación de PQR</a>
                    </h4>
                </div>
                <div id="collapse1" v-show="pqrDisplay" >
                    <div class="panel-body">
                        <emt-form ref="acount-form" v-bind:itemsFormPqr="itemsFormPqr" v-bind:itemsFormAccount="itemsFormAccount" v-bind:itemsFormAttachment="itemsFormAttachment" v-bind:updateData="update" v-bind:resource="itemResource" v-bind:typeactivity="typeactivity"></emt-form>
                    </div>
                </div>
            </div>
        </div>
        <div id="btn-login">
            <button class="btn btn-default" v-on:click="reasignados()" id="btningresar" name="btningresar">Ver reasignaciones</button>
        </div>
        <br>
        <div class="panel-group pqr_panel pqr_panel" id="accordion">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" href="javascript:;" v-on:click="pqrDisplayActivity = !pqrDisplayActivity" id="btn-search">Respuesta de EPM</a>
                    </h4>
                </div>
                <div id="collapse1" v-show="pqrDisplayActivity" >
                    <div class="panel-body">
                        <emt-form ref="acount-form" v-bind:itemsFormActivity="itemsFormActivity" v-bind:itemsFormActivityAttachment="itemsFormActivityAttachment" v-bind:resource="itemResource"  v-bind:typeactivity="typeactivity"  v-on:changeEmail="enabledEmailsActivity"></emt-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-group pqr_panel pqr_panel" id="accordion" v-if="this.activityProvider==='waiting_provider' || this.activityProvider== true">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" href="javascript:;" v-on:click="pqrDisplayActivityProvider = !pqrDisplayActivityProvider" id="btn-search">Respuesta de proveedor</a>
                    </h4>
                </div>
                <div id="collapse1" v-show="pqrDisplayActivityProvider" >
                    <div class="panel-body">
                        <emt-form ref="acount-form" v-bind:itemsFormActivityProvider="itemsFormActivityProvider" v-bind:itemsFormProviderAttachment="itemsFormProviderAttachment" v-bind:resource="itemResource"  v-bind:typeactivity="typeactivity"  v-on:changeEmail="enabledEmailsActivityProvider"></emt-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-group pqr_panel pqr_panel" id="accordion" v-if="this.typeactivity==='pending' || this.typeactivity==='closed'">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" href="javascript:;" v-on:click="pqrDisplayActivityClosed = !pqrDisplayActivityClosed" id="btn-search">Cierre de PQR</a>
                    </h4>
                </div>
                <div id="collapse1" v-show="pqrDisplayActivityClosed" >
                    <div class="panel-body">
                        <emt-form ref="acount-form" v-bind:itemsFormActivityClosed="itemsFormActivityClosed" v-bind:itemsFormClosedAttachment="itemsFormClosedAttachment" v-bind:resource="itemResource"  v-bind:typeactivity="typeactivity" v-on:change="changelist"></emt-form>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import { Arrays } from '@/helpers'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form-pqr'
import EmtLoading from '@/components/emt-loading'
import swal from 'sweetalert2'
var isFilial = Cookies.get('perfil') === 'Consulta filial'
export default {
    name: 'emt-form-register-pqr',
    data: function () {
        return {
            itemsFormPqr: [
                {
                    'name': 'type',
                    'label': 'Tipo PQR',
                    'placeholder': 'Seleccione tipo PQR',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'area',
                    'label': 'Área',
                    'placeholder': 'Seleccione área',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'reason',
                    'label': 'Motivo',
                    'placeholder': 'Seleccione motivo',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'subreason',
                    'label': 'Submotivo',
                    'placeholder': 'Seleccione submotivo',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'user_assigned',
                    'label': 'Usuario asignado',
                    'placeholder': 'Seleccione usuario',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'channel',
                    'label': 'Canal',
                    'placeholder': 'Seleccione canal',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'company',
                    'label': 'Empresa o filial',
                    'placeholder': 'Seleccione empresa',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'process',
                    'label': 'Referencia',
                    'placeholder': 'Ingrese referencia',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                }, {
                    'name': 'gender',
                    'label': 'Género',
                    'placeholder': 'Seleccione el género',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'disabled': 'disabled'
                }, {
                    'name': 'note',
                    'label': 'Descripción',
                    'placeholder': 'Ingrese descripción de la pqr',
                    'value': null,
                    'maxlength': '5000',
                    'type': 'textarea',
                    'rows': '1',
                    'cols': '1',
                    'errors': [],
                    'readonly': 'readonly'
                }
            ],
            itemsFormAccount: [
                {
                    'name': 'document',
                    'label': 'Documento',
                    'placeholder': 'Ingrese Documento',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                },
                {
                    'name': 'name',
                    'label': 'Nombre',
                    'placeholder': 'Ingrese nombre',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                },
                {
                    'name': 'surname',
                    'label': 'Apellido',
                    'placeholder': 'Ingrese Apellido',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                },
                {
                    'name': 'phone_number',
                    'label': 'Número telefonico',
                    'placeholder': 'Ingrese número telefonico',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                },
                {
                    'name': 'cellphone_number',
                    'label': 'Celular',
                    'placeholder': 'Ingrese Celular',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                },
                {
                    'name': 'email',
                    'label': 'Correo electrónico',
                    'placeholder': 'Ingrese correo electrónico',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': [],
                    'readonly': 'readonly'
                }
            ],
            itemsFormAttachment: [
                {
                    'name': 'attachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                    'maximumSize': 20,
                    'downloadOnly': true,
                    'errors': []
                }
            ],
            itemsFormActivityAttachment: [
                {
                    'name': 'activityAttachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                    'maximumSize': 20,
                    'downloadOnly': true,
                    'errors': []
                }
            ],
            itemsFormProviderAttachment: [
                {
                    'name': 'providerAttachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                    'maximumSize': 20,
                    'downloadOnly': true,
                    'errors': []
                }
            ],
            itemsFormClosedAttachment: [
                {
                    'name': 'closeAttachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                    'maximumSize': 20,
                    'downloadOnly': true,
                    'errors': []
                }
            ],
            itemsFormActivity: [
                {
                    'name': 'note',
                    'label': 'Nota',
                    'placeholder': 'Ingrese nota a la pqr',
                    'value': null,
                    'maxlength': '5000',
                    'type': 'textarea',
                    'rows': '10',
                    'cols': '10',
                    'errors': []
                }, {
                    'name': 'waiting_provider',
                    'label': 'Espera de proveedor',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }, {
                    'name': 'attachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'errors': []
                }, {
                    'name': 'user_email',
                    'label': 'Email usuario',
                    'placeholder': 'Email usuario',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }, {
                    'name': 'email_alternative',
                    'label': 'Email usuario alterno',
                    'placeholder': 'Email usuario alterno',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }, {
                    'name': 'email_answer',
                    'label': 'Enviar Respuesta por email?',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }, {
                    'name': 'created_by',
                    'label': 'Usuario respuesta',
                    'placeholder': 'Usuario respuesta',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }, {
                    'name': 'coming_from',
                    'label': 'Procedente',
                    'placeholder': 'Seleccione procedencia',
                    'value': null,
                    'type': 'select',
                    'select_options': [
                        {
                            'value': 'YES',
                            'text': 'Sí'
                        },
                        {
                            'value': 'NO',
                            'text': 'No'
                        },
                        {
                            'value': 'ATTENDED',
                            'text': 'Atendido'
                        }
                    ],
                    'errors': []
                }
            ],
            itemsFormActivityProvider: [
                {
                    'name': 'note',
                    'label': 'Nota',
                    'placeholder': 'Ingrese nota a la pqr',
                    'value': null,
                    'maxlength': '5000',
                    'type': 'textarea',
                    'rows': '10',
                    'cols': '10',
                    'errors': []
                }, {
                    'name': 'attachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'errors': []
                }, {
                    'name': 'email_answer',
                    'label': 'Enviar Respuesta por email?',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }, {
                    'name': 'user_email',
                    'label': 'Email usuario',
                    'placeholder': 'Email usuario',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }, {
                    'name': 'email_alternative',
                    'label': 'Email usuario alterno',
                    'placeholder': 'Email usuario alterno',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }, {
                    'name': 'coming_from',
                    'label': 'Procedente',
                    'placeholder': 'Seleccione procedencia',
                    'value': null,
                    'type': 'select',
                    'select_options': [
                        {
                            'value': 'YES',
                            'text': 'Sí'
                        },
                        {
                            'value': 'NO',
                            'text': 'No'
                        },
                        {
                            'value': 'ATTENDED',
                            'text': 'Atendido'
                        }
                    ],
                    'errors': []
                }, {
                    'name': 'created_by',
                    'label': 'Usuario respuesta',
                    'placeholder': 'Usuario respuesta',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }
            ],
            itemsFormActivityClosed: [
                {
                    'name': 'mark',
                    'label': 'Calificación',
                    'placeholder': 'Ingrese calificación',
                    'value': null,
                    'type': 'select',
                    'select_options': [
                        {
                            'value': 'N/A',
                            'text': 'N/A'
                        },
                        {
                            'value': '1',
                            'text': '1'
                        },
                        {
                            'value': '2',
                            'text': '2'
                        },
                        {
                            'value': '3',
                            'text': '3'
                        },
                        {
                            'value': '4',
                            'text': '4'
                        },
                        {
                            'value': '5',
                            'text': '5'
                        },
                        {
                            'value': '6',
                            'text': '6'
                        },
                        {
                            'value': '7',
                            'text': '7'
                        },
                        {
                            'value': '8',
                            'text': '8'
                        },
                        {
                            'value': '9',
                            'text': '9'
                        },
                        {
                            'value': '10',
                            'text': '10'
                        }
                    ],
                    'errors': []
                }, {
                    'name': 'cause',
                    'label': 'Justificación',
                    'placeholder': 'Ingrese justificación',
                    'value': null,
                    'maxlength': '100',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'close_reason',
                    'label': 'Motivo de cierre',
                    'placeholder': 'Seleccione motivo de cierre',
                    'value': null,
                    'type': 'select',
                    'select_options': [
                        {
                            'value': 'NO_REASON',
                            'text': 'Sin Especificar'
                        },
                        {
                            'value': 'CONTACTED',
                            'text': 'Contactado'
                        },
                        {
                            'value': 'NO_CONTACTED',
                            'text': 'No Contactado'
                        }
                    ],
                    'errors': []
                }, {
                    'name': 'register',
                    'label': 'ID',
                    'placeholder': 'Ingrese ID',
                    'value': null,
                    'maxlength': '20',
                    'type': 'text',
                    'readonly': true,
                    'errors': []
                }, {
                    'name': 'answer',
                    'label': 'Respuesta',
                    'placeholder': 'Ingrese respuesta',
                    'value': null,
                    'maxlength': '5000',
                    'type': 'textarea',
                    'rows': '1',
                    'cols': '1',
                    'errors': []
                }
            ],
            itemResource: [
                {
                    'resourceAccount': '/account/',
                    'resourcePqr': '/pqr/',
                    'resourceAttachment': '/attachment/',
                    'resourceActivity': '/activity/',
                    'resourceActivityFullData': '/activity_full_data/'
                }
            ],
            update: false,
            pqrDisplay: true,
            pqrDisplayActivity: true,
            pqrDisplayActivityProvider: true,
            pqrDisplayActivityClosed: true,
            typeactivity: '',
            emailUserPqr: '',
            activityProvider: false
        }
    },
    methods: {
        /*
        *esta funcion permite inhabilitar los campos dependiendo el estado de la pqr
        */
        enabledForms: function (Activity) {
            var self = this
            if (isFilial === true) {
                for (var form in this.itemsFormActivity) {
                    if (this.itemsFormActivity[form]['type'] === 'checkbox' || this.itemsFormActivity[form]['type'] === 'file' || this.itemsFormActivity[form]['type'] === 'select') {
                        this.itemsFormActivity[form]['disabled'] = 'disabled'
                    } else {
                        this.itemsFormActivity[form]['readonly'] = 'readonly'
                    }
                }
                for (form in this.itemsFormActivityProvider) {
                    if (this.itemsFormActivityProvider[form]['type'] === 'checkbox' || this.itemsFormActivityProvider[form]['type'] === 'file' || this.itemsFormActivityProvider[form]['type'] === 'select') {
                        this.itemsFormActivityProvider[form]['disabled'] = 'disabled'
                    } else {
                        this.itemsFormActivityProvider[form]['readonly'] = 'readonly'
                    }
                }
                for (form in this.itemsFormActivityClosed) {
                    if (this.itemsFormActivityClosed[form]['type'] === 'checkbox' || this.itemsFormActivityClosed[form]['type'] === 'file' || this.itemsFormActivityClosed[form]['type'] === 'select') {
                        this.itemsFormActivityClosed[form]['disabled'] = 'disabled'
                    } else {
                        this.itemsFormActivityClosed[form]['readonly'] = 'readonly'
                    }
                }
            } else {
                if (Activity === 'closed') {
                    for (form in this.itemsFormActivity) {
                        if (this.itemsFormActivity[form]['name'] === 'waiting_provider') {
                            if (this.itemsFormActivity[form]['value'] === true) {
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', false)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', false)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', false)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', false)
                            } else {
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', true)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', true)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', true)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', true)
                            }
                        }
                        if (this.itemsFormActivity[form]['type'] === 'checkbox' || this.itemsFormActivity[form]['type'] === 'file' || this.itemsFormActivity[form]['type'] === 'select') {
                            self.$set(this.itemsFormActivity[form], 'disabled', 'disabled')
                        } else {
                            self.$set(this.itemsFormActivity[form], 'readonly', 'readonly')
                        }
                    }
                    for (form in this.itemsFormActivityProvider) {
                        if (this.itemsFormActivityProvider[form]['type'] === 'checkbox' || this.itemsFormActivityProvider[form]['type'] === 'file' || this.itemsFormActivityProvider[form]['type'] === 'select') {
                            self.$set(this.itemsFormActivityProvider[form], 'disabled', 'disabled')
                        } else {
                            self.$set(this.itemsFormActivityProvider[form], 'readonly', 'readonly')
                        }
                    }
                    for (form in this.itemsFormActivityClosed) {
                        if (this.itemsFormActivityClosed[form]['type'] === 'checkbox' || this.itemsFormActivityClosed[form]['type'] === 'file' || this.itemsFormActivityClosed[form]['type'] === 'select') {
                            self.$set(this.itemsFormActivityClosed[form], 'disabled', 'disabled')
                        } else {
                            self.$set(this.itemsFormActivityClosed[form], 'readonly', 'readonly')
                        }
                    }
                } else if (Activity === 'waiting_provider') {
                    for (var formProvider in this.itemsFormActivity) {
                        if (this.itemsFormActivity[formProvider]['name'] === 'waiting_provider') {
                            if (this.itemsFormActivity[formProvider]['value'] === true) {
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', false)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', false)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', false)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', false)
                            } else {
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', true)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', true)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', true)
                                self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', true)
                            }
                        }
                        if (this.itemsFormActivity[formProvider]['type'] === 'checkbox' || this.itemsFormActivity[formProvider]['type'] === 'file' || this.itemsFormActivity[formProvider]['type'] === 'select') {
                            self.$set(this.itemsFormActivity[formProvider], 'disabled', 'disabled')
                        } else {
                            self.$set(this.itemsFormActivity[formProvider], 'readonly', 'readonly')
                        }
                    }
                } else if (Activity === 'pending') {
                    for (var formPending in this.itemsFormActivity) {
                        if (this.itemsFormActivity[formPending]['name'] === 'waiting_provider') {
                            if (this.itemsFormActivity[formPending]['value'] === true) {
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'user_email'), 'visible', false)
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'email_alternative'), 'visible', false)
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'coming_from'), 'visible', false)
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'email_answer'), 'visible', false)
                            } else {
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'user_email'), 'visible', true)
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'email_alternative'), 'visible', true)
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'coming_from'), 'visible', true)
                                self.$set(Arrays.getItemBy(this.itemsFormActivity, 'name', 'email_answer'), 'visible', true)
                            }
                        }
                        if (this.itemsFormActivity[formPending]['type'] === 'checkbox' || this.itemsFormActivity[formPending]['type'] === 'file' || this.itemsFormActivity[formPending]['type'] === 'select') {
                            self.$set(this.itemsFormActivity[formPending], 'disabled', 'disabled')
                        } else {
                            self.$set(this.itemsFormActivity[formPending], 'readonly', 'readonly')
                        }
                    }
                    for (formPending in this.itemsFormActivityProvider) {
                        if (this.itemsFormActivityProvider[formPending]['type'] === 'checkbox' || this.itemsFormActivityProvider[formPending]['type'] === 'file' || this.itemsFormActivityProvider[formPending]['type'] === 'select') {
                            self.$set(this.itemsFormActivityProvider[formPending], 'disabled', 'disabled')
                        } else {
                            self.$set(this.itemsFormActivityProvider[formPending], 'readonly', 'readonly')
                        }
                    }
                }
            }
        },
        /*
        *esta funcion permite consultar la informacion de la cuenta asociada a esta pqr
        */
        getDataAccount: function (url) {
            let self = this
            url = url + this.$route.params.id + '/'
            self.$http.get(url).then(function (response) {
                url = response.body.account
                self.$http.get(url).then(function (response) {
                    self.setValueAccount(response.body)
                })
            })
        },
        reasignados: function (url) {
            let self = this
            url = Config.api + self.itemResource[0].resourceActivityFullData + '?reassigned=true&pqr=' + this.$route.params.id
            self.$http.get(url).then(function (response) {
                var body = response.body.results
                if (body.length > 0) {
                    var list = '<ul>'
                    for (var i in body) {
                        if (body[i].user_assigned) {
                            list = list + '<li><b>Usuario: </b>' + body[i].created_by + ' <b>Fecha: </b>' + String(body[i].created_at).replace('T', ' ') + '</li>'
                        }
                    }
                    list = list + '</ul>'
                    swal({
                        title: 'Usuarios que reasignaron la pqr',
                        text: '',
                        type: 'info',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'No',
                        html: list
                    })
                } else {
                    swal({
                        title: '',
                        text: '',
                        type: 'info',
                        confirmButtonText: 'Aceptar',
                        html: 'Esta pqr no tiene reasignaciones'
                    })
                }
            })
        },
        /*
        *esta funcion permite listar la informacion de la cuenta asociada a esta pqr
        */
        setValueAccount: function (value) {
            for (var form in this.itemsFormAccount) {
                if (this.itemsFormAccount[form].name === 'email') {
                    this.emailUserPqr = value[this.itemsFormAccount[form].name]
                }
                this.itemsFormAccount[form].value = value[this.itemsFormAccount[form].name]
            }
        },
        /*
        *esta funcion permite consultar la informacion de la pqr
        */
        getDataPqr: function (url) {
            url = url + this.$route.params.id + '/'
            let self = this
            self.$http.get(url).then(function (response) {
                if (response.body['status'] === 'PENDING') {
                    self.typeactivity = 'pending'
                    self.itemsFormClosedAttachment[0].downloadOnly = false
                    if (response.body['waiting_provider']) {
                        self.typeactivity = 'waiting_provider'
                        self.itemsFormProviderAttachment[0].downloadOnly = false
                        self.itemsFormClosedAttachment[0].downloadOnly = true
                        self.activityProvider = true
                    }
                } else if (response.body['status'] === 'CLOSED') {
                    self.typeactivity = 'closed'
                } else if (response.body['status'] === 'SCALED') {
                    self.typeactivity = 'scaled'
                    self.itemsFormActivityAttachment[0].downloadOnly = false
                }
                if (self.typeactivity === 'closed') {
                    self.setValuePqrClosed(response.body)
                }
                self.setValuePqr(response.body)
                self.enabledForms(self.typeactivity, self.activityProvider)
            }, function (response) {
            })
        },
        /*
        *esta funcion permite listar la informacion de la pqr
        */
        setValuePqr: function (value) {
            for (var form in this.itemsFormPqr) {
                if (this.itemsFormPqr[form].type === 'select') {
                    this.itemsFormPqr[form].value = value[this.itemsFormPqr[form].name]
                } else {
                    this.itemsFormPqr[form].value = value[this.itemsFormPqr[form].name]
                }
            }
        },
        getDataAttachment: function (urlAttachment, urlContentType, urlDownload) {
            var self = this
            urlContentType = urlContentType + '?model=pqr'
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + this.$route.params.id
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results
                    self.setValueAttachment(files, urlDownload)
                }, function (response) {
                })
            }, function (response) {
            })
        },
        setValueAttachment: function (files, urlDownload) {
            var self = this
            self.itemsFormAttachment[0].value = []
            for (var file in files) {
                var fileInput = {}
                fileInput.name = files[file].complete_filename
                fileInput.type = files[file].file_mime_type
                fileInput.id = files[file].id
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid
                self.itemsFormAttachment[0].value.push(fileInput)
            }
        },
        getDataProviderAttachment: function (urlAttachment, urlContentType, urlDownload, id) {
            var self = this
            urlContentType = urlContentType + '?model=activity'
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + id
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results
                    self.setValueProviderAttachment(files, urlDownload)
                }, function (response) {
                })
            }, function (response) {
            })
        },
        setValueProviderAttachment: function (files, urlDownload) {
            var self = this
            self.itemsFormProviderAttachment[0].value = []
            for (var file in files) {
                var fileInput = {}
                fileInput.name = files[file].complete_filename
                fileInput.type = files[file].file_mime_type
                fileInput.id = files[file].id
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid
                self.itemsFormProviderAttachment[0].value.push(fileInput)
            }
        },
        getDataActivityAttachment: function (urlAttachment, urlContentType, urlDownload, id) {
            var self = this
            urlContentType = urlContentType + '?model=activity'
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + id
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results
                    self.setValueActivityAttachment(files, urlDownload)
                }, function (response) {
                })
            }, function (response) {
            })
        },
        setValueActivityAttachment: function (files, urlDownload) {
            var self = this
            self.itemsFormActivityAttachment[0].value = []
            for (var file in files) {
                var fileInput = {}
                fileInput.name = files[file].complete_filename
                fileInput.type = files[file].file_mime_type
                fileInput.id = files[file].id
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid
                self.itemsFormActivityAttachment[0].value.push(fileInput)
            }
        },
        getDataClosedAttachment: function (urlAttachment, urlContentType, urlDownload, id) {
            var self = this
            urlContentType = urlContentType + '?model=activity'
            self.$http.get(urlContentType).then(function (response) {
                urlAttachment = urlAttachment + '?content_type=' + response.body.results[0].id + '&object_id=' + id
                self.$http.get(urlAttachment).then(function (response) {
                    var files = response.body.results
                    self.setValueClosedAttachment(files, urlDownload)
                }, function (response) {
                })
            }, function (response) {
            })
        },
        setValueClosedAttachment: function (files, urlDownload) {
            var self = this
            self.itemsFormClosedAttachment[0].value = []
            for (var file in files) {
                var fileInput = {}
                fileInput.name = files[file].complete_filename
                fileInput.type = files[file].file_mime_type
                fileInput.id = files[file].id
                fileInput.link = urlDownload + '?uuid=' + files[file].uuid
                self.itemsFormClosedAttachment[0].value.push(fileInput)
            }
        },
        setValuePqrClosed: function (value) {
            for (var form in this.itemsFormActivityClosed) {
                if (this.itemsFormActivityClosed[form].type === 'select') {
                    this.itemsFormActivityClosed[form].value = value[this.itemsFormActivityClosed[form].name]
                } else {
                    this.itemsFormActivityClosed[form].value = value[this.itemsFormActivityClosed[form].name]
                }
            }
        },
        /*
        *esta funcion permite consultar la informacion de la actividad asociada a esta pqr
        */
        getDataActivity: function (url) {
            url = url + '?pqr=' + this.$route.params.id
            let self = this
            self.$http.get(url).then(function (response) {
                for (var activity in response.body.results) {
                    if (response.body.results[activity].section === 'EPM') {
                        self.getDataActivityAttachment(Config.api + '/attachment/', Config.api + '/content_type/', Config.download, response.body.results[activity].id)
                        self.setValueActivity(response.body.results[activity])
                    }
                    if (response.body.results[activity].section === 'provider') {
                        self.activityProvider = true
                        self.getDataProviderAttachment(Config.api + '/attachment/', Config.api + '/content_type/', Config.download, response.body.results[activity].id)
                        self.setValueActivityProvider(response.body.results[activity])
                    }
                    if (response.body.results[activity].section === 'closed') {
                        self.getDataClosedAttachment(Config.api + '/attachment/', Config.api + '/content_type/', Config.download, response.body.results[activity].id)
                        self.setValuePqrClosed(response.body.results[activity])
                    }
                }
            }, function (response) {
            })
        },
        /*
        *esta funcion permite listar la informacion de la actividad asociada a esta pqr
        */
        setValueActivity: function (value) {
            for (var form in this.itemsFormActivity) {
                if (this.itemsFormActivity[form].type === 'select') {
                    this.itemsFormActivity[form].value = value[this.itemsFormActivity[form].name]
                } else {
                    this.itemsFormActivity[form].value = value[this.itemsFormActivity[form].name]
                }
            }
        },
        setValueActivityProvider: function (value) {
            for (var form in this.itemsFormActivityProvider) {
                if (this.itemsFormActivityProvider[form].type === 'select') {
                    this.itemsFormActivityProvider[form].value = value[this.itemsFormActivityProvider[form].name]
                } else {
                    this.itemsFormActivityProvider[form].value = value[this.itemsFormActivityProvider[form].name]
                }
            }
        },
        /*
        *esta funcion permite consultar y listar las tipos de pqr
        */
        getType: function () {
            var self = this
            self.$http.get(Config.api + '/pqr_type/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[0].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar las unidades
        */
        getUnits: function () {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar las areas
        */
        getArea: function () {
            var self = this
            self.$http.get(Config.api + '/area/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[2].select_options = []
                for (var data in response.body) {
                    self.itemsFormPqr[2].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los Motivos
        */
        getReason: function () {
            var self = this
            self.$http.get(Config.api + '/reason/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[3].select_options = []
                for (var data in response.body) {
                    self.itemsFormPqr[3].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getSubreason: function () {
            var self = this
            self.$http.get(Config.api + '/subreason/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[4].select_options = []
                for (var data in response.body) {
                    self.itemsFormPqr[4].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getUserAssigned: function () {
            var self = this
            self.$http.get(Config.api + '/user/?nopaginate=1&ordering=name').then(function (response) {
                self.itemsFormPqr[5].select_options = []
                for (var data in response.body) {
                    self.itemsFormPqr[5].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getChannel: function () {
            var self = this
            self.$http.get(Config.api + '/channel/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[6].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getCompany: function () {
            var self = this
            self.$http.get(Config.api + '/company/?nopaginate=1&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[7].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        changelist: function (item) {
            var self = this
            if (item.name === 'close_reason') {
                if (item.value === 'CONTACTED') {
                    self.itemsFormActivityClosed[3].readonly = false
                } else {
                    self.itemsFormActivityClosed[3].value = null
                    self.itemsFormActivityClosed[3].readonly = true
                }
            }
        },
        enabledEmails: function (item) {
            var self = this
            if (item.value === true) {
                self.itemsFormActivityClosed[6].value = this.emailUserPqr
                self.itemsFormActivityClosed[6].readonly = false
                self.itemsFormActivityClosed[7].readonly = false
            } else {
                self.itemsFormActivityClosed[6].readonly = true
                self.itemsFormActivityClosed[6].value = null
                self.itemsFormActivityClosed[7].value = null
                self.itemsFormActivityClosed[7].readonly = true
            }
        },
        enabledEmailsActivity: function (item) {
            var self = this
            if (item.name === 'waiting_provider') {
                if (item.value === true) {
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', false)
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', false)
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', false)
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', false)
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer').value = false
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = true
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from').readonly = true
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = true
                } else {
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email'), 'visible', true)
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative'), 'visible', true)
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from'), 'visible', true)
                    self.$set(Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer'), 'visible', true)
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_answer').value = false
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = true
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'coming_from').readonly = true
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = true
                }
            }
            if (item.name === 'email_answer') {
                if (item.value === true) {
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').value = this.emailUserPqr
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = false
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = false
                } else {
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'user_email').readonly = true
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').value = null
                    Arrays.getItemBy(self.itemsFormActivity, 'name', 'email_alternative').readonly = true
                }
            }
        },
        enabledEmailsActivityProvider: function (item) {
            var self = this
            if (item.name === 'email_answer') {
                if (item.value === true) {
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').value = this.emailUserPqr
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').readonly = false
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'email_alternative').readonly = false
                } else {
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').value = null
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'user_email').readonly = true
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'email_alternative').value = null
                    Arrays.getItemBy(self.itemsFormActivityProvider, 'name', 'email_alternative').readonly = true
                }
            }
        },
        /*
        *esta funcion permite consultar y listar los géneros
        */
        getGender: function () {
            var self = this
            self.$http.get(`${Config.api}/gender/?nopaginate=1&ordering=name`).then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[9].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getType()
        this.getUnits()
        this.getArea()
        this.getReason()
        this.getSubreason()
        this.getUserAssigned()
        this.getChannel()
        this.getCompany()
        this.getGender()
    },
    mounted: function () {
        if (this.typeactivity !== 'register') {
            this.getDataAccount(Config.api + '/pqr/')
            this.getDataActivity(Config.api + '/activity_full_data/')
            this.getDataPqr(Config.api + '/pqr/')
            this.getDataAttachment(Config.api + '/attachment/', Config.api + '/content_type/', Config.download)
        }
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-update-pqr.vue?4ff44b68